export default __webpack_public_path__ + "static/media/link-no.5b01ae34.svg";